import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  HiMenuAlt3, 
  HiX, 
  HiOutlineShoppingBag, 
  HiOutlineUserCircle,
  HiOutlineLocationMarker
} from 'react-icons/hi';
import logo from "../../Images/Logo/AstraClean.png";

function CustomNav() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 20);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Close menu on route change
    useEffect(() => {
        setMenuOpen(false);
    }, [location]);

    const openPlayStore = () => {
        window.open('https://play.google.com/store/apps/details?id=com.cleanto.astraclean', '_blank');
    };

    const navLinks = [
        { name: 'Home', path: '/' },
        { name: 'About', path: '/about' },
        { name: 'Services', path: '/services' },
        { name: 'Contact', path: '/contact' },
    ];

    return (
        <header 
            className={`fixed top-0 left-0 right-0 z-[100] transition-all duration-500 ${
                isScrolled 
                ? 'py-3 bg-white/80 backdrop-blur-lg shadow-lg shadow-primary/5' 
                : 'py-6 bg-transparent'
            }`}
        >
            <div className="container-custom flex items-center justify-between">
                {/* Logo */}
                <Link to="/" className="relative z-[110] flex items-center gap-2 group">
                    <img 
                        src={logo} 
                        alt="AstraClean" 
                        className="h-12 md:h-15 w-auto transition-transform duration-300 mix-blend-multiply" 
                    />
                </Link>

                {/* Desktop Navigation */}
                <nav className="hidden lg:flex items-center gap-8">
                    {navLinks.map((link) => (
                        <Link 
                            key={link.path}
                            to={link.path}
                            className={`text-sm font-bold tracking-widest uppercase transition-colors hover:text-primary ${
                                location.pathname === link.path ? 'text-primary' : 'text-foreground/70'
                            }`}
                        >
                            {link.name}
                        </Link>
                    ))}
                </nav>

                {/* Desktop Actions */}
                <div className="hidden lg:flex items-center gap-4">
                    <div className="flex items-center gap-2 text-foreground/60 mr-4 text-xs font-medium">
                        <HiOutlineLocationMarker className="text-primary text-base" />
                        <span>Sarjapur, Bangalore</span>
                    </div>
                    
                    <Link 
                        to="/cart" 
                        className="p-3 rounded-full hover:bg-primary/5 text-foreground/70 hover:text-primary transition-all relative"
                    >
                        <HiOutlineShoppingBag size={22} />
                        <span className="absolute top-2 right-2 w-2 h-2 bg-accent rounded-full border-2 border-white"></span>
                    </Link>

                    <button 
                        onClick={openPlayStore}
                        className="btn-primary !py-2.5 !px-6 !text-sm flex items-center gap-2"
                    >
                        <HiOutlineUserCircle size={18} />
                        LOGIN
                    </button>
                </div>

                {/* Mobile Menu Toggle */}
                <div className="flex lg:hidden items-center gap-4 relative z-[110]">
                    <Link to="/cart" className="p-2 text-foreground/70">
                        <HiOutlineShoppingBag size={24} />
                    </Link>
                    <button 
                        onClick={() => setMenuOpen(!menuOpen)}
                        className="p-2 text-primary focus:outline-none"
                    >
                        {menuOpen ? <HiX size={28} /> : <HiMenuAlt3 size={28} />}
                    </button>
                </div>
            </div>

            {/* Mobile Drawer */}
            <div 
                className={`fixed inset-0 bg-primary/20 backdrop-blur-md z-[100] transition-opacity duration-300 lg:hidden ${
                    menuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
                }`}
                onClick={() => setMenuOpen(false)}
            >
                <div 
                    className={`absolute right-0 top-0 h-full w-[80%] max-w-sm bg-white shadow-2xl transition-transform duration-500 p-8 pt-24 ${
                        menuOpen ? 'translate-x-0' : 'translate-x-full'
                    }`}
                    onClick={e => e.stopPropagation()}
                >
                    <nav className="flex flex-col gap-6">
                        {navLinks.map((link) => (
                            <Link 
                                key={link.path}
                                to={link.path}
                                className={`text-2xl font-bold tracking-tight ${
                                    location.pathname === link.path ? 'text-primary' : 'text-foreground/70'
                                }`}
                            >
                                {link.name}
                            </Link>
                        ))}
                        
                        <hr className="border-border my-2" />
                        
                        <div className="space-y-4">
                            <p className="text-xs uppercase tracking-widest text-muted-foreground font-bold">Services</p>
                            <Link to="/home-cleaning" className="block text-lg font-medium hover:text-primary transition-colors">Full Home Cleaning</Link>
                            <Link to="/sofa-cleaning" className="block text-lg font-medium hover:text-primary transition-colors">Sofa Cleaning</Link>
                            <Link to="/bathroom-cleaning" className="block text-lg font-medium hover:text-primary transition-colors">Bathroom Cleaning</Link>
                            <Link to="/Kitchen-cleaning" className="block text-lg font-medium hover:text-primary transition-colors">Kitchen Cleaning</Link>
                        </div>

                        <div className="mt-auto space-y-4">
                            <button 
                                onClick={openPlayStore}
                                className="w-full btn-primary"
                            >
                                Login / Register
                            </button>
                            <div className="flex items-center justify-center gap-2 text-muted-foreground text-sm">
                                <HiOutlineLocationMarker />
                                <span>Sarjapur, Bangalore</span>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        </header>
    );
}

export default CustomNav;

